(function () {
  try {
    /* main variables */
    var debug = 0;
    var variation_name = "";
    var $;
    
    /* all Pure helper functions */
    function waitForElement(selector, trigger, delayInterval, delayTimeout) {
      var interval = setInterval(function () {
        if (
          document &&
          document.querySelector(selector) &&
          document.querySelectorAll(selector).length > 0
        ) {
          clearInterval(interval);
          trigger();
        }
      }, delayInterval);
      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    function init() {
      document.body.classList.add('AB-039');
    }

    /* Initialize variation */
  if (window.location.pathname === '/' || window.location.pathname.startsWith('/collections/')) {
      waitForElement('.grid-product__price .grid-product__price--savings', init, 50, 15000);
  }
  } catch (e) {
    if (debug) console.log(e, "error in Test" + variation_name);
  }
})();

